export const NOTIFICATION_LOAD = 'notificationChannel/NOTIFICATION_LOAD'
export const NOTIFICATION_CLEAR = 'notificationChannel/NOTIFICATION_CLEAR'
